(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dropmagic-style"]) return;
  try {
    

(function patchBodyClass() {
  if (document.body) {
    document.body.classList.add('theme__modal--callback');
  } else {
    setTimeout(patchBodyClass, 10);
  }
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heldena-kinder-pdp"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hk-pdp').forEach(function(root){var main=root.querySelector('.hk-main-image');var strip=root.querySelector('.hk-thumbs');var thumbs=[].slice.call(root.querySelectorAll('.hk-thumb'));var activeIndex=0;function updateArrows(){var prev=root.querySelector('.hk-gallery-prev');var next=root.querySelector('.hk-gallery-next');if(prev)prev.disabled=activeIndex===0;if(next)next.disabled=activeIndex===thumbs.length-1;}function activate(index,center){if(!thumbs[index])return;activeIndex=index;if(main)main.src=thumbs[index].dataset.image;thumbs.forEach(function(item){item.classList.remove('is-active');});thumbs[index].classList.add('is-active');if(center&&strip)strip.scrollTo({left:thumbs[index].offsetLeft-(strip.clientWidth-thumbs[index].clientWidth)/2,behavior:'smooth'});updateArrows();}thumbs.forEach(function(button,index){button.addEventListener('click',function(){activate(index,true);});});var prev=root.querySelector('.hk-gallery-prev');var next=root.querySelector('.hk-gallery-next');if(prev)prev.addEventListener('click',function(){activate(Math.max(0,activeIndex-1),true);});if(next)next.addEventListener('click',function(){activate(Math.min(thumbs.length-1,activeIndex+1),true);});if(strip&&thumbs.length){var timer;strip.addEventListener('scroll',function(){clearTimeout(timer);timer=setTimeout(function(){var center=strip.scrollLeft+strip.clientWidth/2;var nearest=0;var distance=Infinity;thumbs.forEach(function(item,index){var itemCenter=item.offsetLeft+item.clientWidth/2;var delta=Math.abs(itemCenter-center);if(delta<distance){distance=delta;nearest=index;}});activate(nearest,false);},90);},{passive:true});updateArrows();}var select=root.querySelector('[data-variant-select]');if(select){select.addEventListener('change',function(){var option=select.options[select.selectedIndex];var price=root.querySelector('[data-price]');var add=root.querySelector('.hk-add');if(price)price.textContent=option.dataset.price;if(add){add.disabled=option.dataset.available!=='true';add.textContent=add.disabled?'Ausverkauft':'In den Warenkorb';}var url=new URL(window.location.href);url.searchParams.set('variant',select.value);window.history.replaceState({},'',url);});}});

  } catch(e) { console.error(e); }
})();
})();
